import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { U_LIST_ITEM__user_task_master } from './U_LIST_ITEM__user_task_master';

interface Props {}

export function U_LIST__user_tasks({}: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { workspace_current } = use_slice_workspace(['workspace_current']);
  const { page_tasks_hide_unused } = use_slice_ui(['page_tasks_hide_unused']);
  const { user_task_current, user_tasks_map } = use_slice_generation(['user_task_current', 'user_tasks_map']);

  const items = useMemo(() => Array.from(user_tasks_map.values()), [user_tasks_map]);

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */
  function need_show_item(item: DTO__user_task) {
    let out = true;

    if (workspace_current._id != item.workspace_id) {
      out = false;
    } else if (item._id == user_task_current._id) {
      out = true;
    } else if (page_tasks_hide_unused) {
      out = !item.is_hidden;
    }

    return out;
  }

  /*
   * RENDERS
   */
  function render_items() {
    let items_filtered = items.filter(item => !CONSTANTS__shared.WORKSPACE_SPECIAL_COLLECTION_TYPES.includes(item.type));
    items_filtered = items_filtered.filter(need_show_item);

    items_filtered.sort(DTO__database_entity.sort_by_created_at_newest_first);

    let out = items_filtered.map(user_task => <U_LIST_ITEM__user_task_master key={user_task._id} {...{ user_task }} />);

    return out;
  }

  /*
   * HTML
   */

  return <div className="flex flex-1 flex-col gap-0  overflow-y-auto bg-component p-2">{render_items()}</div>;
}
